import React from 'react';
import classnames from 'classnames';

// Types
import { MetricSlugs } from '../../ManagerDashboardData.constants';

// Components
import WpDataTable from 'Wpds/components/table/WpDataTable';
import MetricsWrapper from '../MetricsWrapper';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

// Styles
import './KeyManagementActivities.scss';

type Props = {
  keyManagementActivities;
};

const KeyManagementActivities = ({ keyManagementActivities }: Props) => {
  const baseClassName = 'KeyManagementActivities';

  const CellComponent = ({ row, selector }) => {
    const selectorValue = row[selector];

    const classes = classnames(
      `${baseClassName}__indicator`,
      selectorValue === 0 && `${baseClassName}__indicator--green`,
      selectorValue === 1 && `${baseClassName}__indicator--yellow`,
      selectorValue === 2 && `${baseClassName}__indicator--red`
    );

    const tooltipCopy = () => {
      switch (`${selector}-${selectorValue}`) {
        case 'one_on_one_color-0':
          return '100% attendance based on scheduled cadence';
        case 'one_on_one_color-1':
          return '50-99% attendance based on scheduled cadence';
        case 'one_on_one_color-2':
          return '<50% attendance based on scheduled cadence';
        case 'feedback_color-0':
          return 'Feedback has been given and received by this person';
        case 'feedback_color-1':
          return 'Feedback has only been given or received by this person';
        case 'feedback_color-2':
          return 'No feedback has occurred involving this person';
        case 'goals_color-0':
          return 'This person has an open Goal with activity in the last 30 days (ie an action item, etc)';
        case 'goals_color-1':
          return 'This person has an open Goal, but no activity on it in the last 30 days';
        case 'goals_color-2':
          return 'This person has no open Goals';
      }
    };

    return (
      <WpTooltip placement="top">
        <WpTooltipTrigger>
          <div className={classes} />
        </WpTooltipTrigger>
        <WpTooltipContent>{tooltipCopy()}</WpTooltipContent>
      </WpTooltip>
    );
  };

  return (
    <MetricsWrapper slug={MetricSlugs.key_management_activties}>
      <div className={baseClassName}>
        <WpDataTable
          columns={[
            { name: 'Report', selector: 'report_name', noWrap: true },
            { name: '1:1s', selector: 'one_on_one_color', component: CellComponent, noWrap: true },
            { name: 'Feedback', selector: 'feedback_color', component: CellComponent, noWrap: true },
            { name: 'Goals', selector: 'goals_color', component: CellComponent, noWrap: true },
          ]}
          rows={keyManagementActivities}
          enableSort={false}
        />
      </div>
    </MetricsWrapper>
  );
};

export default KeyManagementActivities;
